function jqueryAddons($) {
  if ($.inviewport) {
    return;
  }

  $.belowthefold = function(element, settings) {
    const fold = $(window).height() + $(window).scrollTop();
    return fold <= $(element).offset().top - settings.threshold;
  };

  $.abovethetop = function(element, settings) {
    const top = $(window).scrollTop();
    return (
      top >= $(element).offset().top + $(element).height() - settings.threshold
    );
  };

  $.rightofscreen = function(element, settings) {
    const fold = $(window).width() + $(window).scrollLeft();
    return fold <= $(element).offset().left - settings.threshold;
  };

  $.leftofscreen = function(element, settings) {
    const left = $(window).scrollLeft();
    return (
      left >= $(element).offset().left + $(element).width() - settings.threshold
    );
  };

  $.inviewport = (element, settings) =>
    !$.rightofscreen(element, settings) &&
    !$.leftofscreen(element, settings) &&
    !$.belowthefold(element, settings) &&
    !$.abovethetop(element, settings);

  $.extend($.expr[':'], {
    'below-the-fold'(a) {
      return $.belowthefold(a, { threshold: 0 });
    },
    'above-the-top'(a) {
      return $.abovethetop(a, { threshold: 0 });
    },
    'left-of-screen'(a) {
      return $.leftofscreen(a, { threshold: 0 });
    },
    'right-of-screen'(a) {
      return $.rightofscreen(a, { threshold: 0 });
    },
    'in-viewport'(a) {
      return $.inviewport(a, { threshold: 0 });
    },
  });

  /**
   * jQuery function to retrieve all classes from a selector
   *
   * @mixin jQuery.fn.getClasses
   * @returns {Array} classlist
   *
   * @example
   * $(document.body).getClasses()
   */
  window.jQuery.fn.getClasses = function() {
    let ca = this.attr('class');
    let classlist = [];
    if (ca && ca.length && ca.split) {
      ca = window.jQuery.trim(ca); // strip leading and trailing spaces
      ca = ca.replace(/\s+/g, ' '); // remove double spaces
      classlist = ca.split(' ');
    }

    return classlist;
  };

  window.jQuery.fn.getEvents = function(n = 0) {
    return $._data($(this)[n], 'events');
  };
}

module.exports = jqueryAddons;
